import React from 'react'
import { Card, CardGroup } from 'react-bootstrap'

const ArchitecturalModeling = () => {
  return (
    <>
        <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'> 建築モデリング </Card.Title>
                    <Card.Text className='architectural-modeling-text text-left'>
                        建築、エンジニアリング、建設の分野では、建築家やデザイナーのビジョンをクライアントと共有するために、3D平面図や多くの場合物理的なモデルを採用してきました。最近では、VRヘッドセットでCADファイルを閲覧したり、照明や時間帯、天候などをリアルタイムに再現したバーチャルウォークスルーを実現したりするソフトウェアも登場しています。私たちは、デジタル設計されていない既存の建物の3Dモデルを作成するノウハウを持っており、建築前の環境にも同じようなメリットをもたらすことができます。
                        <br />
                        <br /> 
                        既存のすべての物理的環境のデジタルツインを作り上げることができれば、誰もがあらゆる場所を訪れることができる、没入型のヒューマンスケールのバーチャル・キャンパスやツアーを実現することができます。 
                        <br />
                        <br /> 
                        ここでは、ある大学のビジターセンターのバーチャルキャンパスツアーの例を2つご紹介します。
                        <br />
                        <br />
                    </Card.Text>
                    <CardGroup className='architectural-modeling-cardgroup'>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={"/assets/architectural/images/001_001.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'> 大学の校舎 <br />（参考写真） </Card.Title>
                            </Card.Body>
                        </Card>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={"/assets/architectural/images/001_002.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'> アーティスト制作の3Dモデルを <br /> レンダリングしたVRイメージ </Card.Title>
                            </Card.Body>
                        </Card>
                    </CardGroup>

                    <CardGroup className='architectural-modeling-cardgroup mt-5'>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={"/assets/architectural/images/002_001.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'> 大学の校舎 <br />（参考写真） </Card.Title>
                            </Card.Body>
                        </Card>
                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                            <Card.Img className='architectural-modeling-images' src={"/assets/architectural/images/002_002.jpg"} />
                            <Card.Body>
                            <Card.Title className='architectural-modeling-footer-title'> アーティスト制作の3Dモデルを <br /> レンダリングしたVRイメージ </Card.Title>
                            </Card.Body>
                        </Card>
                    </CardGroup>
                </Card.Body>
            </Card>
            <Card className='text-center no-border rounded-0 py-5'>
                <Card.Body>
                    <Card.Subtitle className="industrial-modeling-subtitle py-4"> McKissick美術館3Dモデルのフライオーバー映像  </Card.Subtitle>
                        <div className='industrial-modeling-section'>
                            <video className='industrial-modeling-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                                <source src={"/assets/architectural/video/McKissickMuseum_Flyover_2.mp4"} type="video/mp4"/>
                            </video>
                        </div>
                </Card.Body>
            </Card>
            <Card className='text-center no-border rounded-0 py-4'>
                <Card.Body>
                    <Card.Subtitle className="industrial-modeling-subtitle mt-md-5"> クウェートスカイライン </Card.Subtitle>
                    <Card.Text className='kuwait-text text-left'>
                        クウェート沖の石油・ガス開発プロジェクトのマーケティングビデオのために、街の景観と象徴的な橋を、3Dアニメーションに適したローポリモデルとして再現しました。
                    </Card.Text>
                        <div className='architectural-modeling-kuwait-section'>
                            <video className='architectural-modeling-kuwait-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                                <source src={"/assets/architectural/video/kuwait_merge_with_grid.mp4"} type="video/mp4"/>
                            </video>
                        </div>
                </Card.Body>
            </Card>
        </Card>
    </>
  )
}

export default ArchitecturalModeling
